import React from "react"

import {
  CardFooter,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap"

class CustomPagination extends React.Component {
  state = {
    pages: 0,
    position: 1,
  }

  componentDidMount() {
    this._setPages()
    this._setStartAndEnd()
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.dataLen !== this.props.dataLen) {
      this._setPages()
      this._setStartAndEnd()
    }
    if (prevState.position !== this.state.position) {
      this._setStartAndEnd()
    }
  }

  _setPages() {
    const { dataLen, pageSize } = this.props
    if (dataLen && pageSize) {
      const pages = Math.ceil(dataLen / pageSize)
      this.setState({ pages })
    }
  }

  _setStartAndEnd() {
    const { pageSize } = this.props
    const { position } = this.state
    if (pageSize > 0 && position >= 0) {
      const start = (position - 1) * pageSize
      const end = position * pageSize
      this.props.stateCallback(start, end)
    }
  }

  _handleClick = (e) => {
    e.preventDefault()
    this.setState({ position: parseInt(e.target.innerHTML) }) // innerText
  }

  render() {
    const { dataLen } = this.props
    const { pages, position } = this.state
    return (
      <>
        <CardFooter className="py-4">
          <nav aria-label="...">
            {dataLen > 0 ? (
              <Pagination
                className="pagination justify-content-end mb-0"
                listClassName="justify-content-end mb-0"
              >
                <PaginationItem disabled={position === 1}>
                  <PaginationLink
                    href="#"
                    onClick={(e) => {
                      e.preventDefault()
                      this.setState({ position: this.state.position - 1 })
                    }}
                    tabIndex="-1"
                  >
                    <i className="fas fa-angle-left" />
                    <span className="sr-only">Previous</span>
                  </PaginationLink>
                </PaginationItem>
                {[...Array(pages).keys()].map((page, key) => {
                  return (
                    <PaginationItem
                      key={key}
                      className={page + 1 === position ? "active" : ""}
                    >
                      <PaginationLink
                        href="#"
                        onClick={(e) => {
                          this._handleClick(e)
                        }}
                      >
                        {page + 1}
                      </PaginationLink>
                    </PaginationItem>
                  )
                })}
                <PaginationItem disabled={position === pages}>
                  <PaginationLink
                    href="#"
                    onClick={(e) => {
                      e.preventDefault()
                      this.setState({ position: this.state.position + 1 })
                    }}
                  >
                    <i className="fas fa-angle-right" />
                    <span className="sr-only">Next</span>
                  </PaginationLink>
                </PaginationItem>
              </Pagination>
            ) : null}
          </nav>
        </CardFooter>
      </>
    )
  }
}

CustomPagination.defaultProps = {
  size: 10,
  data: [],
  stateCallback: () => {},
}

export default CustomPagination
